/** Formattazione date e numeri per l'app admin (italiano, ora locale). */

const rtf = new Intl.RelativeTimeFormat('it', { numeric: 'auto' });

export const formatDateTime = (value?: string | null): string =>
    value
        ? new Date(value).toLocaleString('it-IT', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })
        : '—';

export const formatDate = (value?: string | null): string =>
    value ? new Date(value).toLocaleDateString('it-IT', { day: '2-digit', month: 'short', year: 'numeric' }) : '—';

/** "3 ore fa", "ieri", "tra 2 giorni". */
export const formatRelative = (value?: string | null): string => {
    if (!value) return '—';
    const diffSec = (new Date(value).getTime() - Date.now()) / 1000;
    const abs = Math.abs(diffSec);
    if (abs < 60) return 'adesso';
    if (abs < 3600) return rtf.format(Math.round(diffSec / 60), 'minute');
    if (abs < 86400) return rtf.format(Math.round(diffSec / 3600), 'hour');
    if (abs < 86400 * 30) return rtf.format(Math.round(diffSec / 86400), 'day');
    if (abs < 86400 * 365) return rtf.format(Math.round(diffSec / (86400 * 30)), 'month');
    return rtf.format(Math.round(diffSec / (86400 * 365)), 'year');
};

/** Valore per <input type="datetime-local"> da una data ISO (ora locale). */
export const toLocalInputValue = (value?: string | null): string => {
    if (!value) return '';
    const d = new Date(value);
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

/** Da <input type="datetime-local"> (ora locale) a ISO UTC; stringa vuota → null. */
export const fromLocalInputValue = (value: string): string | null =>
    value ? new Date(value).toISOString() : null;

export const initialsOf = (email?: string | null, name?: string | null): string => {
    const source = (name || email || '?').trim();
    const parts = source.split(/[\s.@_-]+/).filter(Boolean);
    return ((parts[0]?.[0] ?? '?') + (parts[1]?.[0] ?? '')).toUpperCase();
};
